/* This file was generated automatically. Do not edit manually. */

export enum SmsUsaRegistrationBusinessRegistrationIdentifier {
    Ein = 'Ein',
    Duns = 'Duns',
    Cbn = 'Cbn',
    Cn = 'Cn',
    Acn = 'Acn',
    Cin = 'Cin',
    Vat = 'Vat',
    VatRn = 'VatRn',
    Rn = 'Rn',
    Other = 'Other',
}
